/**
 * In order to support multiple major versions of Ag Grid in the same project,
 * we need to bundle the styles of Ag Grid v32 and import it as separate style sheet.
 */
// eslint-disable-next-line no-restricted-imports
import '@cmg/data-grid/dist/style.css';

import { initTelemetry, loggerUtil } from '@cmg/common';
import { configureDevValidations, LicenseManager } from '@cmg/data-grid';
import { MuiXProLicenseManager } from '@cmg/design-system';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { getAppSettings } from './config/appSettings';
import { router } from './features/core/router';

const appSettings = getAppSettings();

/**
 * Set the ag-grid enterprise license key
 */
LicenseManager.setLicenseKey(appSettings.licenseKeys.agGridLicenseKey);
/**
 * Set the mui-x license key
 */
MuiXProLicenseManager.setLicenseKey(appSettings.licenseKeys.muiXProLicenseKey);
/**
 * Register ag-grid's dev validations
 */
configureDevValidations({ enabled: appSettings.env.enableDataGridValidations });

loggerUtil.initDatadog({
  clusterEnvironment: appSettings.env.clusterEnvironment,
  datadogApplicationId: appSettings.logging.datadogApplicationId,
  datadogClientToken: appSettings.logging.datadogClientToken,
  serviceName: appSettings.logging.datadogServiceName,
  allowedTracingOrigin: appSettings.logging.datadogTracingOrigin,
  isDevelopment: appSettings.env.isDevelopment,
  version: appSettings.client.appVersionBuild,
});

loggerUtil.initMixpanel({
  token: appSettings.logging.mixPanelToken,
  isDevelopment: appSettings.env.isDevelopment || !appSettings.logging.mixPanelToken, // note: isDevelopment passed here translates to mixpanels debug mode
});

initTelemetry(appSettings).catch(error => console.error('Failed to initialize telemetry:', error));

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  </StrictMode>
);
